export default __webpack_public_path__ + "static/media/termClockDark.68fc67e2.svg";